export const TOKEN_KEY = "ess_access_token";
export const REFRESH_TOKEN_KEY = "ess_refresh_token";
export const USER_SESSION_KEY = "ess_user";
